module.exports = __webpack_public_path__ + "img/404.8b6db5bd.svg";